import { limpiarSesion } from "../utils/sesion";

const BASE_URL = process.env.REACT_APP_API_URL ?? "";
const SESSION_MS = 12 * 60 * 60 * 1000;

async function refreshAccessToken() {
  const refresh = localStorage.getItem("refresh_token");
  if (!refresh) {
    _forceLogout();
    return null;
  }

  try {
    const res = await fetch(`${BASE_URL}/api/core/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh }),
    });

    if (!res.ok) {
      _forceLogout();
      return null;
    }

    const data = await res.json();
    localStorage.setItem("access_token", data.access);
    if (data.refresh) {
      localStorage.setItem("refresh_token", data.refresh);
    }
    return data.access;
  } catch {
    _forceLogout();
    return null;
  }
}

function _forceLogout() {
  // `limpiarSesion` en vez de `localStorage.clear()`: este cierre se dispara
  // cuando el refresh del token falla, que es lo que pasa en cada deploy. Con
  // el clear pelado se borraba también la marca de novedades vistas y el modal
  // del changelog reaparecía en cada actualización del servidor.
  limpiarSesion();
  window.location.href = "/login";
}

/**
 * Header del condominio activo. CONTADOR, AGUA y superadmin no tienen uno
 * fijo: siempre lo mandan. El USUARIO tiene un principal, pero puede tener
 * otros asignados: lo manda cuando eligió uno en el selector (sin header el
 * backend usa el principal). El backend valida que se lo hayan asignado.
 */
export function condominioHeader() {
  const rol     = localStorage.getItem("rol");
  const isSuper = localStorage.getItem("is_superuser") === "true";
  const activo  = localStorage.getItem("active_condominio_id") || "";
  if (rol === "CONTADOR" || rol === "AGUA" || rol === "SEGURIDAD" || isSuper) return { "X-Condominio-ID": activo };
  if (rol === "USUARIO" && activo) return { "X-Condominio-ID": activo };
  return {};
}

export function getAuthHeaders(extraHeaders = {}) {
  const token = localStorage.getItem("access_token");
  const lang  = localStorage.getItem("lang") || "es";
  return {
    "Accept-Language": lang,
    ...condominioHeader(),
    ...extraHeaders,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export default async function apiFetch(path, options = {}) {
  // Reject the call immediately if the 12-hour session has expired.
  const loginAt = parseInt(localStorage.getItem("login_at") || "0", 10);
  if (loginAt && Date.now() - loginAt > SESSION_MS) {
    _forceLogout();
    return new Response(null, { status: 401 });
  }

  const access = localStorage.getItem("access_token");
  const lang   = localStorage.getItem("lang") || "es";
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;

  const makeHeaders = (token) => {
    return {
      // Con FormData no se fija Content-Type: el navegador arma el boundary
      // multipart automáticamente, y si lo forzamos aquí lo rompemos.
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      "Accept-Language": lang,
      ...condominioHeader(),
      ...(options.headers ?? {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  };

  let res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: makeHeaders(access),
  });

  if (res.status === 401) {
    const newToken = await refreshAccessToken();
    if (!newToken) return res;

    res = await fetch(`${BASE_URL}${path}`, {
      ...options,
      headers: makeHeaders(newToken),
    });
  }

  return res;
}
